/**
 * One shared top-right column for the admin pop-up alerts (tech pauses, system health), so they
 * stack under each other instead of being drawn on top of each other. Components portal into it.
 */
let el = null;

export function topRightStack() {
  if (el && document.body.contains(el)) return el;
  el = document.createElement('div');
  el.className = 'sh-stack';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  document.body.appendChild(el);
  return el;
}
